module.exports = __webpack_public_path__ + "img/Artboard 10.b9f7da97.svg";